import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { stateDistricts } from '../../data/stateDistricts';
import {
  CourtLocationForm,
} from '../../utils/constant';
import { courtLocationInitialState as initialState } from './constants';
import { editCourtLocation } from './utils';

const returnAddressSlice = createSlice({
  name: 'returnAddress',
  initialState,
  reducers: {
    updateFormField(
      state,
      action: PayloadAction<{
        fieldName: keyof CourtLocationForm;
        value: string;
      }>,
    ) {
      const { fieldName, value } = action.payload;

      state.formData[fieldName] = value;

      if (fieldName === 'state') {
        state.formData['district'] = '';
      }
    },
    handleCourtLocationSubmit(state) {
      state.formDataErrors = initialState.formDataErrors;
      state.requestSuccess = initialState.requestSuccess;
      state.requestError = initialState.requestError;

      const formData = state.formData;

      if (!formData.state) {
        state.formDataErrors = {
          ...state.formDataErrors,
          stateError: 'State is required',
        };
      }

      if (stateDistricts[formData.state]?.length > 0 && !formData.district) {
        state.formDataErrors = {
          ...state.formDataErrors,
          districtError: 'District is required',
        };
      }
    },
    loadData(state, action) {
      state.formData = action.payload;
    },
    removeSuccessMsg(state) {
      state.requestSuccess = '';
    },
    clearErrors(state) {
      state.formDataErrors = {
        districtError: '',
        divisionError: '',
        stateError: ''
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editCourtLocation.fulfilled, (state, action) => {
        state.formData = action.payload.courtLocation;
        state.requestSuccess = 'Successfully updated court location!';
      })
      .addCase(editCourtLocation.rejected, (state, action) => {
        state.requestError = action.payload
          ? (action.payload as string)
          : 'Something went wrong!';
      });
  },
});

export const {
  updateFormField,
  handleCourtLocationSubmit,
  loadData,
  removeSuccessMsg,
  clearErrors
} = returnAddressSlice.actions;

export default returnAddressSlice.reducer;
